import React from 'react';
import Banner from './Banner';
import Trust from './trust/Trust';
import OurProducts from './our-products/OurProducts';
import WhoWeAre from './WhoWeAre';
import { Link } from 'react-router-dom';
import customerSatisfaction from '../../images/home/customer-satisfaction.png';
import { Helmet } from 'react-helmet';

import './home.scss';

/**
 * Home Component
 * Home page
 */
const Home = props => {
   return (
      <div >
         <Helmet>
            <title>Inheritance Publications: Christian books on history and theology and hundreds of the best children books.</title>
            <meta name="keywords" content="books, historical books, reformed books, reformed books for children, fiction books, reformed church, historical fiction, historical fiction books, short stories, liturgy, reformed worship, 80 years war, 30 years war, world war 2, Bible books, Christian books, Christian literature, literature, Psalm CDs, Hymn CDs, DVDs, Music DVDs, audio books, sheet music, church sheet music, Dutch sheet music, Psalm sheet music, organ sheet music"/>
            <meta name="description" content="Inheritance Publications is a small company which was established to provide Biblical Reformed literature. We want to maintain the antithesis between right and wrong, between true and false christianity. It is also our desire to give God the honour and glory due to His Name because of His faithfulness. Remembering the great deeds of God in the history of His Church will always cause God's children to stand in awe of His Majesty. It is our aim to reach children, young adults, and adults with stories about the history of the Church. We also provide a wide selection of books on the doctrine of the Church. May God's Name be glorified and the readers edified by the reading of our books."/>
         </Helmet>
         <Banner />

         <div className="new-website container-fluid p-5">
            <div className="text-center">
               <h3>Welcome to the new Inheritance Publications website</h3>
               <div className="d-flex">
                  <div className="nw-picture justify-content-center align-items-center">
                     <img src={customerSatisfaction} alt="Customer Satisfaction" />
                  </div>

                  <div className="nw-content">
                     <div className="improvements d-flex justify-content-around w-100">
                        <div>
                           <p>More improvements are coming to serve you better</p>
                        </div>
                     </div>
                     <p>We'd like to hear some feedback from you. For that check out our <Link to="/contact">Contact page</Link></p>
                     <p className="previous-websites">Our full website is still fully up to date. It contains thousands of books from other publishers as well. We regret that at this moment only our own publications are available on this website. You can check the websites at the links below. International customers: please use the U.S. website</p>
                     <div className="old-websites-links d-flex justify-content-around">
                        <a href="http://www.inhpubl.net/canip/products.htm" target="_blank" rel="noopener noreferrer">
                           Canadian Prices
                        </a>
                        <a href="http://www.inhpubl.net/ip/products.htm" target="_blank" rel="noopener noreferrer">
                           U.S. Prices
                        </a>
                     </div>
                  </div>
               </div>
               
            </div>
         </div>

         <Trust />
         <OurProducts setFilter={props.setFilter} updateLastProductPage={props.updateLastProductPage}/>
         <WhoWeAre />

         <div className="container-fluid check-products">
            <div className="row justify-content-center">
               <h3>Check out our products now</h3>
            </div>
            <div className="row justify-content-center">
               <p>May God bless you by providing you with his Word</p>
            </div>
         </div>
      </div>
   )
}

export default Home;